import styled from 'styled-components';
import { variant } from 'styled-system';
import { ThemeUtilities } from '../../../../../theme';

import { Variant } from '../../types';

export const Container = styled.div<{ variant: Variant }>`
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
  transform-origin: 100% 0;

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Watermark', 'variant'))};
`;
